import {axios} from "../../core";

export default {
    getAll: () => axios.get("/dialogs"),
    create: ({text, category_id}) => axios.post("/user/dialogs/create", {text, category_id}),
    rating: ({dialog_id, vote, text}) => axios.put(`/user/dialogs/rating/${dialog_id}`, {vote, text})
};
